import { ReactElement } from "react"
import { Shader } from "./shader"
import { Plugin } from "./plugin"

export type Character = string | number
export type Pattern = Character[]
export type Unit = Character | Pattern
export type Tick = number

export const isPattern = (unit: Unit): unit is Pattern => {
    return Array.isArray(unit)
}

export type GPUState = number

export type RenderOutput = ReactElement

export type RenderInput = Unit[][]

export type Render = (
    input: RenderInput,
    state: GPUState,
    resolution: Resolution,
    shaders?: Shader[],
    plugins?: Plugin[],
) => RenderOutput

export type UseGpuReturnType = [
    (input: RenderInput,  shaders?: Shader[], plugins?: Plugin[],) => RenderOutput,
    GPUState,
    {
        setTick: (tick: Tick) => void
        getMaxTick: () => Tick
    },
]

export type Resolution = {
    width: number,
    height: number,
}

export type GPUOptions = {
    tickRate: number,
    resetOnMax?: boolean,
    resolution: Resolution,
}
export type UseGPUFn = (options: GPUOptions) => UseGpuReturnType





